import { AfterViewInit, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'abq-auto-close',
    templateUrl: './logged-shown.component.html',
    styleUrls: ['./logged-shown.component.scss'],
    imports: [RouterLink]
})
export class LoggedShownComponent implements AfterViewInit {
    public ngAfterViewInit(): void {
        window.close();
    }
}
